<template>
  <div class="tasking">
    <List
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      offset="600"
    >
      <router-link to="" class="eve-mytask" :style="randomRgb()" v-for="item in list" :key="item.id">
        <div class="task-list__header" >
          <div class="task-header__left">{{item.task_title || '-'}}</div>
          <div class="task-header__right">
            <img :src="item.avatarurl || defualtImg" alt="">
            <div>{{item.username}}</div>
          </div>
        </div>
        <div class="task-footer">
          <div class="footer-time">
            <span>{{item.plan_start_time.substr(0,10)  || ''}}</span>
            <span> ~ </span>
            <span>{{item.plan_end_time.substr(0,10)  || ''}}</span>
          </div>
          <div class="task-footer-type">
            <div class="footer-nos" >ing</div>
            <!-- <div class="footer-derl" @click.prevent.stop="getTask (item.id)">抢单</div> -->
          </div>
        </div>
        <div class="task-main">
          <div class="task-main__left">
            <div class="task-left__type">
              {{item.task_mech}}
            </div>
            <div class="task-left__jin" v-if="item.urgent_level == '紧急'">
              {{item.urgent_level}}
            </div>
          </div>
          <div class="task-header__right">￥{{item.award | strChange}}</div>
        </div>
      </router-link>
    </List>
    <div class="backof" v-if="!list.length">还未有朋友领任务，快去分享吧！</div>
  </div>
</template>

<script>
import { shareTask } from '@/api/api/wechat'
import { List } from 'vant'
export default {
  data() {
    return {
      defualtImg: require('@/assets/image/head.jpg'),
      finished: false,
      list: [],
      page: 0,
      isloading: false,
      total: 0
    };
  },
  components: {
    List
  },
  created() {
    this.getTask()
  },
  methods: {
    randomRgb() {
      var col = ['#d9f5f8', '#ffedd9', '#eceaff', '#ffe5e6']
      var bor = ['#57ccd8', '#ff9b2b', '#938bff', '#ff6d6e']
      let R = Math.floor(Math.random() * 4)
        return {
          'background-color': col[R],
         "border-left": "6px solid "+bor[R]+""
        }
    },
    getTask() {
      this.page++
      shareTask().then(res => {
        this.list = res.data.data.list
        this.total = res.data.data.total
        setTimeout(() => {
          this.isloading = true
        },1000)
      })
    },
    onLoad() {
      if(!this.isloading) return
      if(this.total < 10) {
        this.nomore = true
        return
      }
      if((this.page *10) < this.total) {
        this.isloading = false
        this.getTask()
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tasking {
  padding: 10px 24px;
  .backof {
    text-align: center;
    padding: 20px;
    color: #ccc;
    font-weight: 700;
    font-size: 16px;
  }
  .eve-mytask {
    border-radius: 6px;
    display: block;
    height: 138px;
    background: #d9f5f8;
    margin-bottom: 16px;
    border-left: 1px solid rgb(201, 58, 58);
    padding: 17px 25px 0 21px;
    .task-footer {
      display: flex;
      justify-content: space-between;
      height: 38px;
      margin-bottom: 4px;
      .task-footer-type {
        display: flex;
          .footer-nos {
            height: 38px;
            width: 38px;
            text-align: center;
            line-height: 38px;
            color: white;
            font-weight: 600;
            font-size: 16px;
            border-radius: 50%;
            background-color: #ff6565;
          }
          .footer-derl {
            width: 72px;
            height: 25px;
            text-align: center;
            line-height: 25px;
            color: white;
            background: #BE0000;
            border-radius: 2px;
        }
      }
      .footer-time {
        margin-top: 8px;
        color: #828593;
      }
    }
    .task-list__header {
      padding-bottom: 8px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .task-header__left {
        height:21px;
        font-weight: 700;
        font-size: 15px;
        color: #25245D;
        letter-spacing: 0.5px;
      }
      .task-header__right {
        display: flex;
        align-items: center;
        img {
          width: 28px;
          height: 28px;
          margin-right: 14px;
        }
        .sizelit {
          font-size: 10px;
        }
      }
    }
  }
  .task-main {
      display: flex;
      justify-content: space-between;
      height: 36px;
      margin-bottom: 8px;
      line-height: 36px;
      .task-header__right {
        font-size: 16px;
        color: #ff6565;
      }
      .task-main__right {
        margin-top: 10px;
        color: #BE0000;
      }
      .task-main__left {
        display: flex;
        .task-left__type {
          width: 36px;
          height: 36px;
          border: 2px solid white;
          border-radius: 50%;
          text-align: center;
          line-height: 36px;
          background: #F3F3F3;
          font-size: 12px;
          color:#8988AB;
          margin-right: 8px;
        }
        .task-left__jin {
          padding: 0 6px;
          height: 20px;
          border-radius: 50%;
          background: #F91400;
          text-align: center;
          line-height: 20px;
          font-size: 12px;
          color:white;
        }
      }
        
    }
}
</style>